import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const LiabilitySection = () => (
  <>
    <SectionHeading>Our Liability</SectionHeading>

    <ListItem marker="(a)">
      {"Except where prohibited by law, We accept no liability in relation to Your participation (or inability to participate) in any Promotion, including without limitation any use made by You of (or inability to use) any Prize, to the maximum extent permitted by law."}
    </ListItem>

    <ListItem marker="(b)" withBottomMargin>
      {"If any Promotion cannot be executed as planned, including due to any technical problems or circumstances beyond Our control, We shall incur no liability and no bonus, payment or prize of any kind will be awarded."}
    </ListItem>
  </>
);

export default LiabilitySection;
